const SESSION_KEY = 'crane_game_session_id';

export function createSessionId(): string {
  return `s_${Date.now()}_${Math.random().toString(36).substring(2, 9)}`;
}

export function getCurrentSessionId(): string | null {
  return sessionStorage.getItem(SESSION_KEY);
}

export function setCurrentSessionId(sessionId: string): void {
  sessionStorage.setItem(SESSION_KEY, sessionId);
}

export function clearCurrentSessionId(): void {
  sessionStorage.removeItem(SESSION_KEY);
}
